import {Injectable} from "@angular/core";
import {CanActivate, Router} from "@angular/router";
import * as moment from "moment";
import {FacebookService} from "ng2-facebook-sdk";
import {TranslateService} from "@ngx-translate/core";
import {AngularFireAuth} from "angularfire2/auth";
import {Observable} from "rxjs/Observable";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private translate: TranslateService, public afAuth: AngularFireAuth) {
  }

  canActivate(): Observable<boolean> {
    return this.afAuth && this.afAuth.authState && this.afAuth.authState.map(authState => {
      if (!authState) this.router.navigate([`/login`]);
      return !!authState;
    }).take(1);
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/guards/auth.guard.ts